/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedInvestmentRangeDtoSchema = z.object({
  tier: z.optional(z.string()),
  amount: z.optional(z.string()),
  description: z.optional(z.string()),
  highlight: z.optional(z.boolean()),
});
